import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Tomato from "./views";
import "./index.css";

const routes = [
  {
    path: "/3bb76e94",
    element: <Tomato />,
    extract: true,
  },
  {
    path: "*",
    element: <Tomato />,
    extract: true,
  },
];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
